import { BusinessPreview } from '@/components/organisms/BusinessPreview';
import { cn } from '@/lib/classNames';
import { useRef } from 'react';
import { useAddContactDataMutation } from './hooks/useAddContactDataMutation';
import { useGetEmailQuery } from './hooks/useGetEmailQuery';
import { useReminderMutation } from './hooks/useReminderMutation';
import { useRemoveContactDataMutation } from './hooks/useRemoveContactDataMutation';
import { useRemoveNoteMutation } from './hooks/useRemoveNoteMutation';
import { useReportDataMutation } from './hooks/useReportDataMutation';
import { useTaskData } from './hooks/useTaskData';
import { useUserData } from './hooks/useUserData';
import { useSaveNoteMutation } from './hooks/useSaveNoteMutation';
import { useSelectBusinessMutation } from './hooks/useSelectBusinessMutation';
import { useSelectedBusinessData } from './hooks/useSelectedBusinessData';

export const SearchBusinessesBusinessPreview = () => {
	const { selectedBusiness } = useSelectedBusinessData();
	const { user } = useUserData();

	const {
		isError: isTaskError,
		isLoading: isTaskLoading,
		isSuccess: isTaskSuccess
	} = useTaskData();
	const { onResetReminder, onDeleteReminder, onSetReminder } =
		useReminderMutation();

	const { mutate: mutateSaveNote } = useSaveNoteMutation();
	const { mutate: mutateGetEmailQuery } = useGetEmailQuery();
	const { mutate: mutateSelectBusiness } = useSelectBusinessMutation();
	const {
		mutate: mutateReportData,
		isError: isReportIncorrectDataError,
		isLoading: isReportIncorrectDataLoading,
		isSuccess: isReportIncorrectDataSuccess
	} = useReportDataMutation();
	const { mutate: mutateRemoveNote } = useRemoveNoteMutation();
	const {
		mutate: mutateAddContactData,
		isError: isContactDataError,
		isLoading: isContactDataLoading,
		isSuccess: isContactDataSuccess
	} = useAddContactDataMutation();
	const { mutate: mutateRemoveContactData } = useRemoveContactDataMutation();

	const lastBusinessIdRef = useRef<string | null>(null);

	return (
		<div
			data-is-visible={Boolean(
				selectedBusiness?._id ||
					selectedBusiness?.businessId ||
					selectedBusiness?.id
			)}
			className={cn(
				'absolute left-full right-0 z-20 flex h-full max-w-lg flex-col overflow-hidden rounded-tl-lg border border-orange-brighter bg-dm-black shadow-md 3xl:relative',
				'w-0 transition',
				'data-[is-visible=true]:w-[95%] data-[is-visible=true]:-translate-x-full 3xl:data-[is-visible=true]:left-0 3xl:data-[is-visible=true]:ml-4 3xl:data-[is-visible=true]:w-full 3xl:data-[is-visible=true]:translate-x-0'
			)}
		>
			<BusinessPreview
				lastBusinessIdRef={lastBusinessIdRef}
				listId={selectedBusiness?.listId}
				user={user}
				selectedBusiness={selectedBusiness}
				isReportIncorrectDataError={isReportIncorrectDataError}
				isReportIncorrectDataLoading={isReportIncorrectDataLoading}
				isReportIncorrectDataSuccess={isReportIncorrectDataSuccess}
				onSaveNote={mutateSaveNote}
				onSelectBusiness={mutateSelectBusiness}
				onGetEmailThread={mutateGetEmailQuery}
				onReportIncorrectData={mutateReportData}
				onRemoveNote={mutateRemoveNote}
				onRemoveContactData={mutateRemoveContactData}
				onAddContactData={mutateAddContactData}
				isContactDataError={isContactDataError}
				isContactDataLoading={isContactDataLoading}
				isContactDataSuccess={isContactDataSuccess}
				isTaskLoading={isTaskLoading}
				isTaskError={isTaskError}
				isTaskSuccess={isTaskSuccess}
				onDeleteReminder={onDeleteReminder}
				onResetReminder={onResetReminder}
				onSetReminder={onSetReminder}
			/>
		</div>
	);
};
